import { CommonModule } from "@angular/common";
import { SectionHeroModule } from "../app/sectionHero/section-hero.module";
import * as i0 from "@angular/core";
export class CompatSectionHeroModule {
}
CompatSectionHeroModule.ɵfac = function CompatSectionHeroModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatSectionHeroModule)(); };
CompatSectionHeroModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompatSectionHeroModule });
CompatSectionHeroModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [SectionHeroModule, CommonModule] });
